import { Component, OnInit, ViewChild } from "@angular/core";
import { Storage } from "../../storage/storage";

@Component({
  selector: "app-send-oracle-cart",
  templateUrl: "./send-oracle-cart.component.html",
  styleUrls: ["./send-oracle-cart.component.css"],
})
export class SendOracleCartComponent implements OnInit {
  buyer_form_post_url: any;

  xml: any;

  @ViewChild("testForm") testFormElement;

  constructor(private storage: Storage) {
    this.buyer_form_post_url = this.storage.hook_url;
    this.xml = this.storage.xmlData;
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    console.log("---< submit");
    this.testFormElement.nativeElement.submit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/send-oracle-cart/send-oracle-cart.component.ts